// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.careers-container{
    padding:20px 0px;
    padding-top: 130px;
    
}

.careers{
  padding:0px 10%;
}

.careers h1{
    font-family: 'Raleway',sans-serif;
    color:#E42727;
}

.careers p{
        text-align: left;
        /* color: #444; */
        font-family: 'Poppins', sans-serif;
        letter-spacing: 1px;

}

.careers-dropdown{
    padding:0px 10%;
    display: flex;
    flex-direction: row;
    align-items: center;

}

.careers-dropdown h2{
    font-family: 'Raleway',sans-serif;
    font-weight: 500;

}
.careers-dropdown select{
    width:300px;
    height:40px;
    margin-left: 20px;
}

.job-description{
    padding:0px 10%;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    text-align: left;
}

.job-description p{
    font-family: 'Poppins',sans-serif;
    /* color:#444; */
    letter-spacing: 1px;
}

.apply-button{
    width:150px;
    height:50px;
    background-color:#e42727;
    color:#fff;
    font-family: 'Poppins',sans-serif;
    letter-spacing: 1px;
    position: relative;
        overflow: hidden;
        cursor: pointer;
    
        z-index: 0;
}


 
  










  .apply-button::after {
      /* this is what all  will be done when mouse outs from the button */
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: #f9c12e;
      z-index: -1;

      transition: 0.3s ease all;
      transform: scale(0, 1);

      /* this is you are to change for diffirent transition; */

      transform-origin: bottom left;
      transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
      transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
  }



  .apply-button:hover::after {
      transform: scale(1, 1);
      transform-origin: top left;
  }

  @media screen and (max-width:768px){
    .careers-container {
            padding: 20px 0px;
            padding-top: 180px;
    
        }
  }

`, "",{"version":3,"sources":["webpack://./src/Styles/Careers.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,iCAAiC;IACjC,aAAa;AACjB;;AAEA;QACQ,gBAAgB;QAChB,iBAAiB;QACjB,kCAAkC;QAClC,mBAAmB;;AAE3B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;AAEvB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;;AAEpB;AACA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,UAAU;IACV,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;QACd,gBAAgB;QAChB,eAAe;;QAEf,UAAU;AAClB;;;;;;;;;;;;;;;EAeE;MACI,mEAAmE;MACnE,WAAW;MACX,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,YAAY;MACZ,WAAW;MACX,yBAAyB;MACzB,WAAW;;MAEX,yBAAyB;MACzB,sBAAsB;;MAEtB,wDAAwD;;MAExD,6BAA6B;MAC7B,0DAA0D;MAC1D,0DAA0D;EAC9D;;;;EAIA;MACI,sBAAsB;MACtB,0BAA0B;EAC9B;;EAEA;IACE;YACQ,iBAAiB;YACjB,kBAAkB;;QAEtB;EACN","sourcesContent":[".careers-container{\n    padding:20px 0px;\n    padding-top: 130px;\n    \n}\n\n.careers{\n  padding:0px 10%;\n}\n\n.careers h1{\n    font-family: 'Raleway',sans-serif;\n    color:#E42727;\n}\n\n.careers p{\n        text-align: left;\n        /* color: #444; */\n        font-family: 'Poppins', sans-serif;\n        letter-spacing: 1px;\n\n}\n\n.careers-dropdown{\n    padding:0px 10%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n}\n\n.careers-dropdown h2{\n    font-family: 'Raleway',sans-serif;\n    font-weight: 500;\n\n}\n.careers-dropdown select{\n    width:300px;\n    height:40px;\n    margin-left: 20px;\n}\n\n.job-description{\n    padding:0px 10%;\n    display: flex;\n    flex-direction: column;\n    align-content: flex-start;\n    text-align: left;\n}\n\n.job-description p{\n    font-family: 'Poppins',sans-serif;\n    /* color:#444; */\n    letter-spacing: 1px;\n}\n\n.apply-button{\n    width:150px;\n    height:50px;\n    background-color:#e42727;\n    color:#fff;\n    font-family: 'Poppins',sans-serif;\n    letter-spacing: 1px;\n    position: relative;\n        overflow: hidden;\n        cursor: pointer;\n    \n        z-index: 0;\n}\n\n\n \n  \n\n\n\n\n\n\n\n\n\n\n  .apply-button::after {\n      /* this is what all  will be done when mouse outs from the button */\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      width: 100%;\n      background-color: #f9c12e;\n      z-index: -1;\n\n      transition: 0.3s ease all;\n      transform: scale(0, 1);\n\n      /* this is you are to change for diffirent transition; */\n\n      transform-origin: bottom left;\n      transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n      transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n  }\n\n\n\n  .apply-button:hover::after {\n      transform: scale(1, 1);\n      transform-origin: top left;\n  }\n\n  @media screen and (max-width:768px){\n    .careers-container {\n            padding: 20px 0px;\n            padding-top: 180px;\n    \n        }\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
